import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

export const getZonesByRestaurant = async (restaurantId) => {
  try {
    const response = await axios.get(`${BASE_API}/public/zones/restaurant/${restaurantId}`);
    // API returns { data: [...], total: X }, extract the data array
    return response.data?.data || [];
  } catch (error) {
    throw error;
  }
};
